// extracted by mini-css-extract-plugin
export default {"header_container":"style_header_container__UhATh","left_area":"style_left_area__rrmH9","heading":"style_heading__Cq+M6","sub_heading":"style_sub_heading__id7P1"};